import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export class ExporterService {
	static readonly EXCEL_TYPE =
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	static readonly CSV_TYPE = "text/csv;charset=UTF-8";
	static readonly EXCEL_EXTENSION = ".xlsx";
	static readonly CSV_EXTENSION = ".csv";

	static exportAsExcel<T extends Record<string, unknown>>(
		json: T[],
		excelFileName: string,
		columns?: { field: string; header: string }[]
	) {
		let worksheet: XLSX.WorkSheet;

		if (columns?.length) {
			const headers = columns.map(c => c.header);
			const rows = json.map(record => columns.map(c => record[c.field] ?? ""));

			worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
		} else {
			worksheet = XLSX.utils.json_to_sheet(json);
		}

		const objectMaxLength: number[] = [];
		const range = XLSX.utils.decode_range(worksheet["!ref"] || "A1");

		for (let C = range.s.c; C <= range.e.c; ++C) {
			let maxWidth = 10;

			for (let R = range.s.r; R <= range.e.r; ++R) {
				const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
				if (cell?.v) {
					const len = cell.v.toString().length;
					if (len > maxWidth) maxWidth = len;
				}
			}

			objectMaxLength[C] = maxWidth + 2;
		}

		worksheet["!cols"] = objectMaxLength.map(w => ({ width: w }));

		const workbook: XLSX.WorkBook = { Sheets: { report: worksheet }, SheetNames: ["report"] };
		const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
		const data = new Blob([wbout], { type: this.EXCEL_TYPE });

		saveAs(data, excelFileName + this.EXCEL_EXTENSION);
	}

	static exportAsCsv(data: object[], filename: string, separator: string = ",") {
		const headers = Object.keys(data[0]).join(separator) + "\n";
		const rows = data.map(obj => Object.values(obj).join(separator)).join("\n");
		const csvContent = data.length ? headers + rows : "";
		const blob = new Blob([csvContent], { type: this.CSV_TYPE });

		saveAs(blob, filename + this.CSV_EXTENSION);
	}

	static saveAsCSV(buffer: ArrayBuffer, fileName: string) {
		saveAs(new Blob([buffer], { type: this.CSV_TYPE }), fileName + this.CSV_EXTENSION);
	}
}
